export default __webpack_public_path__ + "static/media/visor purple.f47624eb.png";